import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function RetailWithPinIcon(props) {
  return (
    <SvgIcon viewBox="0 0 62 62" title="Retail with Map Pin" {...props}>
      <g clipPath="url(#clip0_1710_5193)">
        <path
          d="M58.8054 20.4787H58.8027C57.8374 18.6467 56.8907 16.844 56.4187 15.308C55.2374 11.4707 53.4667 4.892 53.4667 0.233337H8.89337C8.89337 6.14 5.98937 13.0733 3.56271 18.86C1.82404 23.004 0.333374 26.564 0.333374 28.7373C0.333374 30.6547 1.97871 30.9293 3.28537 30.9293H17.2134C20.1067 26.3587 25.2027 23.3133 31 23.3133C36.7974 23.3133 41.8934 26.356 44.7867 30.9293H58.4854C60.1734 30.9293 61.7334 30.9293 61.7334 28.188C61.7334 26.052 60.248 23.2253 58.8054 20.4787Z"
          fill="#8A8A8A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.0107 39.588H30.9894C30.9894 39.588 30.968 39.604 30.968 39.6093V39.6307C30.968 39.6307 30.984 39.652 30.9894 39.652C30.9894 39.652 30.992 39.652 31 39.652H31.0107C31.0107 39.652 31.032 39.636 31.032 39.628V39.6067C31.032 39.6067 31.016 39.5853 31.0107 39.5853V39.588Z"
          fill="#C6C6C6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.7653 30.8973C46.3706 33.4227 47.3066 36.4147 47.3066 39.62C47.3066 44.2307 45.0346 49.9347 40.5573 56.572C40.5146 56.636 40.472 56.7 40.4266 56.7613L56.6586 56.9347V30.8973H44.7653Z"
          fill="#C6C6C6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6934 39.62C14.6934 36.412 15.6267 33.42 17.2347 30.8973H5.40002V56.3907L21.4347 56.5613C16.9627 49.9293 14.6934 44.228 14.6934 39.62Z"
          fill="#C6C6C6"
        />
        <path
          d="M11.304 26.6253C13.1653 26.6253 13.6987 23.1613 13.6987 23.1613L17.16 3.96399H12.9013L9.17599 23.428C9.17599 23.428 8.64265 26.6253 11.304 26.6253Z"
          fill="white"
        />
        <path
          d="M49.3494 24.7613C49.3494 24.7613 50.1494 27.1613 52.2774 27.1613C54.4054 27.1613 53.8747 23.6973 53.8747 23.6973L49.8827 4.23334H45.8907L49.3494 24.764V24.7613Z"
          fill="white"
        />
        <path
          d="M17.0427 48.86H15.5013V55.2067H20.544C19.1147 52.9773 17.9493 50.86 17.0427 48.86Z"
          fill="#55565A"
        />
        <path
          d="M31.0001 27.58C24.3441 27.58 18.9601 32.964 18.9601 39.62C18.9601 48.6493 31.0001 61.98 31.0001 61.98C31.0001 61.98 43.0401 48.6493 43.0401 39.62C43.0401 32.964 37.6561 27.58 31.0001 27.58ZM31.0001 43.9187C28.6268 43.9187 26.7014 41.9933 26.7014 39.62C26.7014 37.2467 28.6268 35.3214 31.0001 35.3214C33.3734 35.3214 35.2987 37.2467 35.2987 39.62C35.2987 41.9933 33.3734 43.9187 31.0001 43.9187Z"
          fill="#368007"
        />
        <path
          d="M49.7413 48.988V47.1107V46.4493L47.96 48.988H49.7413Z"
          fill="black"
        />
        <path
          d="M47.3067 39.62C47.3067 39.8093 47.2961 40.004 47.2881 40.1986L49.7414 37.5746H48.4747L47.2854 38.8146C47.2987 39.0813 47.3067 39.348 47.3067 39.6173V39.62Z"
          fill="black"
        />
        <path
          d="M44.8987 48.988H46.0213L49.7413 44.484V41.5347L46.1174 45.9613C45.7814 46.9373 45.376 47.948 44.8987 48.988Z"
          fill="black"
        />
        <path
          d="M46.5121 44.7133L49.7414 40.9853V38.228L47.2374 40.9773C47.1307 42.1586 46.8881 43.4066 46.5094 44.7133H46.5121Z"
          fill="black"
        />
        <path
          d="M47.1733 37.5773C47.2587 38.2467 47.3067 38.9293 47.3067 39.62C47.3067 42.364 46.496 45.5 44.8987 48.988H49.7413V37.5773H47.1733Z"
          fill="#D5EDF9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4427 56.5747C16.9627 49.9373 14.6934 44.2333 14.6934 39.6227C14.6934 38.2307 14.8694 36.8813 15.1974 35.5933H14.0374V56.4253L21.4587 56.5987C21.4587 56.5987 21.448 56.5853 21.4427 56.5773V56.5747Z"
          fill="#2C2D31"
        />
        <path
          d="M30.7173 23.3213C30.8106 23.3213 30.904 23.3133 31 23.3133C32.136 23.3133 33.2426 23.4307 34.3146 23.652C34.4213 22.9107 34.4506 22.3587 34.4506 22.3587L33.92 3.96399H29.928L30.7253 23.1613C30.7253 23.1613 30.7226 23.22 30.7173 23.3213Z"
          fill="white"
        />
        <path
          d="M24.44 24.6973C24.872 23.4333 24.872 22.0947 24.872 22.0947L25.6693 3.96399H20.88L20.3467 22.8947C20.3467 22.8947 20.3467 25.6093 21.2427 26.564C22.2267 25.8253 23.3013 25.1987 24.44 24.6973Z"
          fill="white"
        />
        <path
          d="M42.6987 27.6947C44.5627 27.6973 44.2961 23.4307 44.2961 23.4307L41.9014 3.96667H38.4427L40.5707 24.2307C40.5707 24.2307 40.8347 27.6947 42.6987 27.6947Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1710_5193">
          <rect
            width="61.4"
            height="61.7467"
            fill="white"
            transform="translate(0.333374 0.233337)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
export default RetailWithPinIcon;
